import { useEffect, useState } from 'react';
import { Theme, useMediaQuery, useTheme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import { useAppDispatch } from '../../../store/hooks';
import { PageTransition } from './common/PageTransition';
import { useSolutionOrg } from '../../../config/useSolutionOrg';
import { getOnboardingForm } from '../../../store/thunks/onboardingThunk';
import { useCustomEventTracking } from '../../../common/useCustomEventTracking';
import { OnboardHomeComponentV2 } from './common/OnboardHomeComponentV2';

interface OnboardHomeProps {
  optionalContainerStyle?: (theme: Theme) => SystemStyleObject<Theme>;
}

export function OnboardHome({
  optionalContainerStyle,
}: OnboardHomeProps) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isOnboarding, setIsOnboarding] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [variant, setVariant] = useState(2);
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const { trackRequest } = useCustomEventTracking();

  const {
    envSolutionOrgFormId,
  } = useSolutionOrg();
  const onboardFormId = envSolutionOrgFormId as string;

  useEffect(() => {
    dispatch(getOnboardingForm(
      {
        formId: onboardFormId,
        trackRequest,
      },
    ));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line no-nested-ternary
  const onboardHomeComponent = (
    (<OnboardHomeComponentV2
      onboardFormId={onboardFormId}
    />
    )
  );

  return (
    <>
      {isDesktop ?
        <PageTransition>
          {onboardHomeComponent}
        </PageTransition> :
        onboardHomeComponent
      }
    </>
  );
}
